const messages = {
    en: {
        commenttSuccess: "Report has been added successfully",
        commenttError: "Error while adding report",
        maximumNumberOfComments: "Maximum number of reports",
        perDay: " per day"
    },
    ru: {
        commenttSuccess: "Жалоба успешно добавлена",
        commenttError: "Ошибка при добавлении жалобы",
        maximumNumberOfComments: "Максимальное количество жалоб",
        perDay: " в день"
    }
  };

  export default messages;